import React from 'react';
import PropTypes from 'prop-types';

import Tab from 'react/containers/layout/tabs/Tab';
import { PhotoAlbumList } from './PhotoAlbumList';

class PhotoAlbum extends Tab {
  render() {
    const { active, updateTitle, tab: { key } } = this.props;
    updateTitle({
      key,
      title: Monet.I18n.getResourcesByKey('photoalbum.userinterface.description')
    });
    const className = `gmTabs__panel ${(active) ? 'is-active' : ''}`;

    return (
      <div id="PhotoAlbum" className={className}>
        <PhotoAlbumList />
      </div>
    );
  }
}

PhotoAlbum.propTypes = {
  active: PropTypes.bool,
  tab: PropTypes.object,
  updateTitle: PropTypes.func
};

PhotoAlbum.defaultProps = {
  active: false,
  tab: {},
  updateTitle: () => null
};

export default PhotoAlbum;
